export function createReferralLinks({
  activeTab,
  isFromSubDomain,
  referralCode,
  referrerId,
  subDomainUrl,
}: {
  activeTab: string;
  isFromSubDomain?: boolean;
  referralCode?: string;
  referrerId: string;
  subDomainUrl?: string;
}) {
  if (isFromSubDomain && activeTab === 'affiliate') {
    return null;
  }

  const referralBaseUrl = isFromSubDomain
    ? subDomainUrl
    : activeTab === 'affiliate'
      ? (import.meta.env.VITE_APP_AFFILIATE_URI as string)
      : (import.meta.env.VITE_APP_CUSTOMER_URI as string);
  const referralCodeParam = activeTab === 'affiliate' ? 'Id' : 'ReferCode';
  const referralCodeValue = referralCode || referrerId;
  const createReferralUrl = (type: 'L' | 'Q') => {
    const referralLink = new URL(referralBaseUrl!);
    referralLink.searchParams.set(referralCodeParam, referralCodeValue);
    referralLink.searchParams.set('Type', type);
    return referralLink.toString().replace(/\/(?=\?)/, '');
  };

  return {
    referralUrl: createReferralUrl('L'),
    qrUrl: createReferralUrl('Q'),
  };
}
